"use strict";

// TODO - this file should be removed when module system is fully built out
module.exports = {
  hasTexture1: false,
  hasTextureCube1: false,

  enableLights: false,
  useReflection: false,

  // picking configs
  enablePicking: false,
  hasPickingColors: false,

  // fog configuration
  hasFog: false
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9leHBlcmltZW50YWwvc2hhZGVycy9kZWZhdWx0LXVuaWZvcm1zLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJoYXNUZXh0dXJlMSIsImhhc1RleHR1cmVDdWJlMSIsImVuYWJsZUxpZ2h0cyIsInVzZVJlZmxlY3Rpb24iLCJlbmFibGVQaWNraW5nIiwiaGFzUGlja2luZ0NvbG9ycyIsImhhc0ZvZyJdLCJtYXBwaW5ncyI6Ijs7QUFBQTtBQUNBQSxPQUFPQyxPQUFQLEdBQWlCO0FBQ2ZDLGVBQWEsS0FERTtBQUVmQyxtQkFBaUIsS0FGRjs7QUFJZkMsZ0JBQWMsS0FKQztBQUtmQyxpQkFBZSxLQUxBOztBQU9mO0FBQ0FDLGlCQUFlLEtBUkE7QUFTZkMsb0JBQWtCLEtBVEg7O0FBV2Y7QUFDQUMsVUFBUTtBQVpPLENBQWpCIiwiZmlsZSI6ImRlZmF1bHQtdW5pZm9ybXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBUT0RPIC0gdGhpcyBmaWxlIHNob3VsZCBiZSByZW1vdmVkIHdoZW4gbW9kdWxlIHN5c3RlbSBpcyBmdWxseSBidWlsdCBvdXRcbm1vZHVsZS5leHBvcnRzID0ge1xuICBoYXNUZXh0dXJlMTogZmFsc2UsXG4gIGhhc1RleHR1cmVDdWJlMTogZmFsc2UsXG5cbiAgZW5hYmxlTGlnaHRzOiBmYWxzZSxcbiAgdXNlUmVmbGVjdGlvbjogZmFsc2UsXG5cbiAgLy8gcGlja2luZyBjb25maWdzXG4gIGVuYWJsZVBpY2tpbmc6IGZhbHNlLFxuICBoYXNQaWNraW5nQ29sb3JzOiBmYWxzZSxcblxuICAvLyBmb2cgY29uZmlndXJhdGlvblxuICBoYXNGb2c6IGZhbHNlXG59O1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/react-vis/~/luma.gl/dist/experimental/shaders/default-uniforms.js
// module id = 764
// module chunks = 0